<template>
  <div id="contents">
    <div class="recruit_top_message" >
      <div class="recruit_top_message_main">
        <div class="title_area">
          <p class="title">TOP MESSAGE</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" />
        </div>
        <div class="main_image">
          <img src="../assets/img/common/recruit_2022/top_message/main.png" />
        </div>
        <div class="message">
          <h3>いいものを創り続けるということ</h3>
          <p>テレビ朝日映像は、テレビ番組をはじめとするさまざまなコンテンツを創り出す、ディレクターたちやプロデューサーたちの、ものづくり集団です。その昔、私がテレビの世界に入った時、自分の創り出したテレビ番組を、どこかで知らない誰かが見てくれて、その中の一人でも幸せな気持ちになってくれたなら、これほど嬉しいことはない、と思って仕事をしていました。そんな気持ちは、今でも変わりません。</p>
          <p>我々が創るものが、どこかの誰かを幸せにしたり、笑顔にしたり、少しだけ人生に深みをもたらしたり、ドキドキしたり、いつもより深く物事を考えたり。我々はそんなコンテンツを、いいものを、創り続けたい、送り届けたい、そう思っています。</p>
        </div>
        <div class="info">
          <p class="position">テレビ朝日映像株式会社<br />代表取締役社長 兼 エグゼクティブプロデューサー</p>
          <p class="sign"><img src="../assets/img/common/recruit_2022/top_message/sign.png" alt="若林邦彦" width="179"/></p>
        </div>
        <div class="profile">
          <div class="text_area">
            <img src="../assets/img/common/recruit_2022/top_message/pink_line.png" />
            <p>慶応義塾大学卒業後、1981年テレビ朝日に入社。1985年放送開始の「ニュースステーション」の立ち上げに参加し、ディレクター、プロデューサーを担当。その後「スマステーション」ジェネラルプロデューサーなどを歴任。2004年「報道ステーション」を立ち上げ、以降16年間、総合演出、統括エグゼクティブプロデューサーを務める。2020年テレビ朝日映像の代表取締役社長 兼 エグゼクティブプロデューサーに就任。趣味はイヤホンとヘッドホン探し。</p>
          </div>
        </div>

      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_top_message',
  data() {
    return {
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_top_message
    &_main
      width: 1000px
      margin: 161px auto 150px
      padding: 92px 0 75px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -49px
        left: 55px
      .title
        @include recruit_font(41px, 64px, .176em)
        color: #fff
        background: #E60000
        padding: 5px 19px 9px 18px
        display: table
      .close_icon
        position: absolute
        right: 0px
        top: -65px
        img
          width: 40px
          height: 40px
      .main_image
        width: 653px
        height: 435px
        margin: 0 auto 43px
        img
          width: 100%
      .message
        width: 890px
        margin: 0 auto
        h3
          @include recruit_font(30px, 1, .196em)
          position: relative
          z-index: 1
          text-align: center
          margin: 0 auto 66px
          &::after
            content: ""
            position: absolute
            top: 24px
            left: 50%
            transform: translate(-50%, 0%)
            z-index: -1
            width: 553px
            height: 14px
            margin: 0 auto
            background: #FF7689
        p
          @include recruit_font(14px, 2em, .130em)
          margin: 25px 0 0
          &:first-child
            margin: 0
      .info
        width: 890px
        margin: 60px auto 50px
        .position
          @include recruit_font(12px, 1.8em, .196em)
          text-align: right
        .sign
          margin: 15px 0 0
          text-align: right
      .profile
        display: flex
        justify-content: space-between
        width: 890px
        margin: 0 auto
        .image_area
          margin-right: 40px
          img
            width: 140px
            height: 140px
        .text_area
          h3
            @include recruit_font(22px, 22px, .206em)
            display: inline-block
            margin: 9px 0 19px
            color: #FF7689
          img
            width: 100%
            height: 3px
            margin-bottom: 13px
            display: block
          p
            @include recruit_font(12px, 23px, .206em)
</style>



// WEBPACK FOOTER //
// src/components/recruit_top_message.vue